import { ConflictType, WorkFileConflictResponseDto } from '../_generated/api/workfile-import'
import ApiModel from './ApiModel'

export default class WorkfileConflict extends ApiModel<WorkFileConflictResponseDto> {
    get id() {
        return this.data.conflictId ?? ''
    }

    get type() {
        return this.data.type ?? ConflictType.None
    }
}
